import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { LocalStorageService } from 'ngx-webstorage';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
 
@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private loaderService: LoaderService,private router: Router,private sessionSt: LocalStorageService,
    private modalService: NgbModal) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }
 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Do not show global loading for postcode/address lookup so typing is not covered by loader
    const isAddressLookup = req.url.includes('address/search') || req.url.includes('address/get');
    if (!isAddressLookup) {
      this.requests.push(req);
      this.loaderService.isLoading.next(true);
    }
    return Observable.create(observer => {
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse && event.body) {
             if(event.body.error_code == 401) {
                this.sessionSt.clear();
                this.modalService.dismissAll();
                this.router.navigateByUrl("/");
              } else if(event.body.status_code == 409) {
                this.sessionSt.store('unauthorized_msg',event.body.message);
                this.router.navigateByUrl("unauthorized");
              }
              if (!isAddressLookup) this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            if (!isAddressLookup) this.removeRequest(req);
            observer.error(err);
          },
          () => {
            if (!isAddressLookup) this.removeRequest(req);
            observer.complete();
          });
      // remove request from queue when cancelled
      return () => {
        if (!isAddressLookup) this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
